import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LogoutMessageDraftModal } from '@/components/LogoutMessageDraftModal/LogoutMessageDraftModal';
import { PartitionSync } from '@/components/PartitionSync/PartitionSync';
import { isAppAccessLocked } from '@/helpers/appErrorSession';
import { ROUTE_ALIASES } from '@/routing/routesAliases';

const ALLOWED_PATHS_WHEN_LOCKED = new Set<string>([
  ROUTE_ALIASES.ERROR,
  ROUTE_ALIASES.LOGOUT,
  ROUTE_ALIASES.AUTH_CALLBACK_PAGE,
]);

export const AccessLockOutlet = () => {
  const location = useLocation();

  if (isAppAccessLocked() && !ALLOWED_PATHS_WHEN_LOCKED.has(location.pathname)) {
    return <Navigate to={ROUTE_ALIASES.ERROR} replace />;
  }

  return (
    <>
      <PartitionSync />
      <Outlet />
      <LogoutMessageDraftModal />
    </>
  );
};
